module.exports = __webpack_public_path__ + "img/meta.d311700b.png";